import Vue from 'vue'
import Vuex from 'vuex'
import { getStorage, setStorage } from 'api/user'
import storage from 'good-storage'
import company from './modules/company'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: getStorage('user'),
    currentCompany: getStorage('currentCompany'),
    messageCount: storage.session.get('message_count'),
    pendingCount: storage.session.get('pending_count'),
    checkTaskDetail: [],
    keepArray: [],
    sixSPassWord: '',
    YearScoreRank: null,
    MonthScoreRank: null
  },
  mutations: {
    setUser (state, userData) {
      state.user = userData
    },
    removeUser (state) {
      state.user = null
    },
    setCompany (state, item) {
      state.currentCompany = item
      setStorage('currentCompany', item)
    },
    setMessageCount (state, count) {
      state.messageCount = count
      storage.session.set('message_count', count)
    },
    setPendingCount (state, count) {
      state.pendingCount = count
      storage.session.set('pending_count', count)
    },
    loginOutSet (state) {
      state.messageCount = 0
      state.user = ''
      state.currentCompany = ''
    },
    clearKeep (state) {
      state.keepArray = []
    },
    setKeep (state, name) {
      state.keepArray.push(name)
    },
    setCheckTaskDetail (state, checkTaskDetail) {
      state.checkTaskDetail = checkTaskDetail
    },
    removeKeep (state, name) {
      let index = 0
      for (let item of state.keepArray) {
        if (item == name) {
          state.keepArray.splice(index, 1)
          break
        }
        index++
      }
    },
    setSixSPassWord (state, item) {
      state.sixSPassWord = item
    },
    setYearScoreRank (state, item) {
      state.YearScoreRank = item
    },
    setMonthScoreRank (state, item) {
      state.MonthScoreRank = item
    }
  },
  // getters
  getters: {
    checkTaskDetail: state =>
      state.checkTaskDetail
  },

  actions: {
    checkTaskDetail (context, seek) {
      console.log(seek)
      context.commit('checkTaskDetail')
    }
  },
  modules: {
    company
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js